/**
 * Static-translations for sv. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const sv = {
  'anon.heading_default': 'Fortsätt som gäst',
  'anon.try_again': 'Försök igen',
  'auth.back_to_login': 'Tillbaka till inloggning',
  'auth.check_email_message': 'Kontrollera din e-post — vi har skickat en bekräftelsekod.',
  'auth.check_email_title': 'Kontrollera din e-post',
  'auth.confirm_email_title': 'Bekräfta din e-post',
  'auth.confirmation_code': 'Bekräftelsekod',
  'auth.continue_with_apple': 'Fortsätt med Apple',
  'auth.continue_with_facebook': 'Fortsätt med Facebook',
  'auth.continue_with_github': 'Fortsätt med GitHub',
  'auth.continue_with_google': 'Fortsätt med Google',
  'auth.create_account': 'Skapa konto',
  'auth.default_subtitle': 'Logga in för att få tillgång till alla funktioner och synkronisera din data.',
  'auth.email': 'E-postadress',
  'auth.email_already_registered': 'Den här e-postadressen är redan registrerad. Logga in nedan med ditt lösenord eller kontot du registrerade dig med.',
  'auth.email_exists': 'Ett konto med denna e-post finns redan.',
  'auth.email_not_confirmed': 'Bekräfta din e-post först.',
  'auth.forgot_password': 'Glömt lösenord?',
  'auth.forgot_password_title': 'Glömt lösenord?',
  'auth.forgot_subtitle': 'Ange din e-post så skickar vi en länk för att återställa ditt lösenord.',
  'auth.generic_error': 'Något gick fel',
  'auth.have_account': 'Har du redan ett konto?',
  'auth.hide_password': 'Dölj lösenord',
  'auth.identity_already_linked': 'Det här kontot är redan registrerat. Logga in med det nedan.',
  'auth.invalid_credentials': 'Felaktig e-post eller lösenord',
  'auth.invalid_otp': 'Koden är ogiltig eller har gått ut.',
  'auth.last_used': 'Senast använd · {email}',
  'auth.last_used_no_email': 'Senast använd',
  'auth.link_purchase_subheading': 'Vi länkar köpet till ditt konto för att behålla åtkomsten.',
  'auth.log_in': 'Logga In',
  'auth.log_in_link': 'Logga In',
  'auth.login_continue_purchase': 'Logga in för att fortsätta ditt köp',
  'auth.network_error': 'Nätverksfel. Kontrollera anslutningen och försök igen.',
  'auth.no_account': 'Har du inget konto?',
  'auth.or': 'eller',
  'auth.password': 'Lösenord',
  'auth.passwords_mismatch': 'Lösenorden matchar inte',
  'auth.rate_limited': 'För många förfrågningar. Försök igen senare.',
  'auth.repeat_password': 'Upprepa lösenord',
  'auth.reset_link_valid': 'Länken är giltig i 1 timme.',
  'auth.reset_password_title': 'Återställ lösenord',
  'auth.reset_sent_message': 'Om e-postadressen finns har en återställningskod skickats.',
  'auth.reset_sent_subtitle': 'Vi har skickat en länk för att återställa lösenordet. Följ instruktionerna i e-postmeddelandet.',
  'auth.restore_purchases_heading': 'Återställ Köp',
  'auth.restore_purchases_subheading': 'Logga in för att återställa dina köp.',
  'auth.send_reset': 'Skicka Återställningsmail',
  'auth.service_unavailable': 'Tjänsten är tillfälligt otillgänglig. Försök igen senare.',
  'auth.show_password': 'Visa lösenord',
  'auth.sign_out': 'Logga ut',
  'auth.sign_up': 'Registrera',
  'auth.sign_up_link': 'Registrera',
  'auth.signed_in': 'Inloggad',
  'auth.signin_failed': 'Inloggning misslyckades',
  'auth.signup_failed': 'Registrering misslyckades',
  'auth.verify': 'Verifiera',
  'auth.weak_password': 'Lösenordet är för svagt.',
  'auth.welcome': 'Välkommen!',
  'auth.welcome_signup': 'Välkommen!',
  'cta.close': 'Stäng',
  'cta.continue': 'Fortsätt',
  'cta.get_lifetime_access': 'Få livstidsåtkomst',
  'cta.get_plan_daily': 'Hämta daglig plan',
  'cta.get_plan_monthly': 'Hämta månadsplan',
  'cta.get_plan_weekly': 'Hämta veckoplan',
  'cta.get_plan_yearly': 'Hämta årsplan',
  'cta.start_trial': 'Starta {days} Dagars Gratis Provperiod',
  'modal.close_aria': 'Stäng',
  'modal.continue': 'Fortsätt',
  'modal.error_generic': 'Något gick fel',
  'modal.loading': 'Laddar…',
  'modal.purchase_restored_subtitle': 'Allt är klart — ha så kul!',
  'modal.purchase_restored_title': 'Välkommen tillbaka',
  'modal.purchase_success_subtitle': 'Allt är klart — ha så kul!',
  'modal.purchase_success_title': 'Betalning mottagen',
  'modal.verifying_subscription': 'Kontrollerar prenumeration…',
  'nav.back': '← Tillbaka',
  'nav.back_aria': 'Tillbaka',
  'offer.limited_time': 'Tidsbegränsat erbjudande',
  'payment.awaiting_title': 'Slutför betalningen i den nya fliken',
  'payment.checking': 'Kontrollerar…',
  'payment.ive_paid': 'Jag har betalat',
  'payment.open_checkout_again': 'Öppna kassan igen',
  'payment.open_checkout_button': 'Öppna kassan',
  'pricing.free_trial_days': '{days} dagars gratis provperiod',
  'pricing.included_per': 'Ingår per {interval}:',
  'pricing.interval.day': 'dag',
  'pricing.interval.lifetime_short': 'livstid',
  'pricing.interval.month': 'månad',
  'pricing.interval.period': 'period',
  'pricing.interval.week': 'vecka',
  'pricing.interval.year': 'år',
  'pricing.money_back': '30 dagars pengarna-tillbaka-garanti',
  'pricing.most_popular': 'Populärast',
  'pricing.no_prices': 'Inga priser tillgängliga.',
  'pricing.plan_label.daily': 'DAGLIG PLAN',
  'pricing.plan_label.lifetime': 'livstid',
  'pricing.plan_label.monthly': 'månadsplan',
  'pricing.plan_label.weekly': 'veckoplan',
  'pricing.plan_label.yearly': 'årsplan',
  'pricing.plans_aria': 'Planer',
  'session.contact_support': 'Kontakta support',
  'session.restore_purchases': 'Återställ köp',
  'session.sign_out': 'Logga ut',
  'session.signed_in_as_prefix': 'Inloggad som',
  'session.signing_out': 'Loggar ut…',
  'support.attachments_label': 'Bilagor',
  'support.close_button': 'Stäng',
  'support.done_button': 'Klart',
  'support.email_placeholder': 'Ange din e-post',
  'support.heading': 'Support',
  'support.instruction': 'Fyll i formuläret nedan för att skicka din supportförfrågan.',
  'support.invalid_email': 'Ogiltig e-post',
  'support.message_length': '1–5000 tecken',
  'support.message_placeholder': 'Ange ditt meddelande',
  'support.required': 'Obligatoriskt',
  'support.send_another': 'Skicka ytterligare förfrågan',
  'support.send_button': 'Skicka',
  'support.sending': 'Skickar…',
  'support.subject_length': '3–200 tecken',
  'support.subject_placeholder': 'Ange ditt ämne',
  'support.success_heading': 'Förfrågan skickad',
  'support.success_message_prefix': 'Vi har tagit emot ditt meddelande och svarar på'
} as const;

export default sv;
